<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" title="在线用户" width="70%">
      <div class="default-table">
        <el-table :data="dataList">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="用户名称" prop="user_name"></el-table-column>
          <el-table-column label="登录时间" prop="login_time">
            <template slot-scope="{row}">
              <span>{{$utils.parseTime(row.login_time,'{y}-{m}-{d} {h}:{i}:{s}')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="登录IP" prop="ip"></el-table-column>
          <el-table-column label="访问地址" prop="address"></el-table-column>
          <el-table-column label="设备" prop="device"></el-table-column>
          <el-table-column label="设备类型" prop="device_type"></el-table-column>
          <el-table-column label="浏览器" prop="browser"></el-table-column>
          <el-table-column label="设备类型" prop="device_type"></el-table-column>
          <el-table-column label="语言" prop="language"></el-table-column>
          <el-table-column label="创建时间" prop="created_at"></el-table-column>
          <el-table-column label="修改时间" prop="updated_at"></el-table-column>
        </el-table>
        <div class="table-page">
          <div class="table-pagination">
            <Pagination :limit.sync="queryParams.per_page" :page.sync="queryParams.page" :total.sync="total"
                        @pagination="getList"/>
          </div>
          <div class="table-do">
            <el-tooltip class="item" effect="dark" content="刷新表格" placement="top">
              <el-button @click="getList" icon="el-icon-refresh" circle
                         style="margin-left:15px;margin-top: 10px"></el-button>
            </el-tooltip>
          </div>

        </div>
      </div>

      <!--      <div slot="footer">-->
      <!--        <el-button @click="close">取消</el-button>-->
      <!--        <el-button type="primary" @click="handelConfirm">确定</el-button>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>
<script>
import {getUseOnlineList} from "../../api/user";

export default {
  name: 'userOnline',
  inheritAttrs: false,
  components: {},
  props: [],
  data() {
    return {
      dataList: [],
      queryParams: {page: 1, per_page: 15},
      total: 0,
      formData: {
        mobile: '',
      },
      rules: {
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1(3|4|5|7|8|9)\d{9}$/,
          message: '手机号格式错误',
          trigger: 'blur'
        }],
      },
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onOpen() {
      this.getList()
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
    },

    getList() {
      //加载列表
      getUseOnlineList(this.queryParams).then(res => {
        this.dataList = res.model.data || []
        this.total = res.model.total || 0
      })
    }
  }
}

</script>
<style>
.table-page {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.table-pagination {
  height: 50px;
}

.table-do {
  white-space: nowrap;
}
</style>
